import Vue from "vue";

Vue.component("modification-viewer", {
    props: ["historyType"],   
    data() {
        return {
            showModal: false,
            modalTitle: null,
            loading: true,
            hasNameColumn: false,
            hasOriginalNameColumn: false,
            hasTextColumn: false,
            hasFooterColumn: false,
            hasDescriptionColumn: false,
            hasDetailsTextColumn: false,
            histories: [],
            language: 'en',
            languages: {
                'en': 'EN',
                'fr': 'FR',
                'es': 'ES'
            }
        };
    },
    methods: {
        close() {
            this.showModal = false;
            this.histories = [];
        },
        initialize(id) {
            const self = this;
            self.loading = true;

            switch (self.historyType) {
                case 'ENTITY':
                    self.modalTitle = "Entity History";
                    self.hasNameColumn = true;
                    self.hasOriginalNameColumn = true;
                    self.hasTextColumn = false;
                    self.hasFooterColumn = false;
                    self.hasDescriptionColumn = false;
                    self.hasDetailsTextColumn = false;

                    self.$services.modification.searchHistoryEntities({
                        entityId: id,
                        language: window.currentLanguage
                    }).then((response) => {
                        self.histories = response.histories;

                        self.loading = false;
                    });

                    break;
                case 'NOTE':
                    self.modalTitle = "Note History";
                    self.hasNameColumn = false;
                    self.hasOriginalNameColumn = false;
                    self.hasTextColumn = true;
                    self.hasFooterColumn = true;
                    self.hasDescriptionColumn = false;
                    self.hasDetailsTextColumn = false;

                    self.$services.modification.searchHistoryNotes({
                        noteId: id,
                        language: window.currentLanguage
                    }).then((response) => {
                        self.histories = response.histories;

                        self.loading = false;
                    });

                    break;
                case 'NOTEITEM':
                    self.modalTitle = "Note Item History";
                    self.hasNameColumn = false;
                    self.hasOriginalNameColumn = false;
                    self.hasTextColumn = false;
                    self.hasFooterColumn = false;
                    self.hasDescriptionColumn = true;
                    self.hasDetailsTextColumn = true;

                    self.$services.modification.searchHistoryNoteItems({
                        noteItemId: id,
                        language: window.currentLanguage
                    }).then((response) => {
                        self.histories = response.histories;

                        self.loading = false;
                    });

                    break;
                case 'GOODS':
                    self.modalTitle = "Goods History";
                    self.hasNameColumn = false;
                    self.hasOriginalNameColumn = false;
                    self.hasTextColumn = true;
                    self.hasFooterColumn = false;
                    self.hasDescriptionColumn = false;
                    self.hasDetailsTextColumn = false;

                    self.$services.modification.searchHistoryGoods({
                        goodId: id,
                        language: window.currentLanguage
                    }).then((response) => {
                        self.histories = response.histories;

                        self.loading = false;
                    });

                    break;
                case 'SERVICE':
                    self.modalTitle = "Services History";
                    self.hasNameColumn = false;
                    self.hasOriginalNameColumn = false;
                    self.hasTextColumn = true;
                    self.hasFooterColumn = true;
                    self.hasDescriptionColumn = false;
                    self.hasDetailsTextColumn = false;

                    self.$services.modification.searchHistoryServices({
                        serviceId: id,
                        language: window.currentLanguage
                    }).then((response) => {
                        self.histories = response.histories;

                        self.loading = false;
                    });

                    break;
                case 'CONSTRUCTIONSERVICE':
                    self.modalTitle = "Construction Services History";
                    self.hasNameColumn = false;
                    self.hasOriginalNameColumn = false;
                    self.hasTextColumn = true;
                    self.hasFooterColumn = false;
                    self.hasDescriptionColumn = false;
                    self.hasDetailsTextColumn = false;

                    self.$services.modification.searchHistoryConstructionServices({
                        constructionServiceId: id,
                        language: window.currentLanguage
                    }).then((response) => {
                        self.histories = response.histories;

                        self.loading = false;
                    });

                    break;
            }

            self.showModal = true;
        }
    },
    computed: {
        modificationViewerEntityHistoryLabel: function () {
            return window.labels.modificationViewerEntityHistory;
        },
        modificationViewerNoteHistoryLabel: function () {
            return window.labels.modificationViewerNoteHistory;
        },
        modificationViewerNoteItemHistoryLabel: function () {
            return window.labels.modificationViewerNoteItemHistory;
        },
        modificationViewerGoodsHistoryLabel: function () {
            return window.labels.modificationViewerGoodsHistory;
        },
        modificationViewerServiceHistoryLabel: function () {
            return window.labels.modificationViewerServiceHistory;
        },
        modificationViewerConstructionServiceHistoryLabel: function () {
            return window.labels.modificationViewerConstructionServiceHistory;
        },
        modificationViewerChangeTypeLabel: function () {
            return window.labels.modificationViewerChangeType;
        },
        modificationViewerChangeDateLabel: function () {
            return window.labels.modificationViewerChangeDate;
        },
        modificationViewerReferenceNumberLabel: function () {
            return window.labels.modificationViewerReferenceNumber;
        },
        modificationViewerNameLabel: function () {
            return window.labels.modificationViewerName;
        },
        modificationViewerOriginalNameLabel: function () {
            return window.labels.modificationViewerOriginalName;
        },
        modificationViewerTextLabel: function () {
            return window.labels.modificationViewerText;
        },
        modificationViewerFooterLabel: function () {
            return window.labels.modificationViewerFooter;
        },
        modificationViewerDescriptionLabel: function () {
            return window.labels.modificationViewerDescription;
        },
        modificationViewerDetailsLabel: function () {
            return window.labels.modificationViewerDetails;
        },
        modificationViewerDocumentSymbolLabel: function () {
            return window.labels.modificationViewerDocumentSymbol;
        },
        modificationViewerCloseLabel: function () {
            return window.labels.modificationViewerClose;
        }

    },
    template: `
        <b-modal full-screen id="modificationViewerModal" width="1200px" ref="modificationViewerModal" v-model="showModal" #default="props" :can-cancel="['escape','x']">
            <div class="modal-card" style="overflow-y: auto;">
                <header class="modal-card-head">
                    <p class="modal-card-title">{{ modalTitle }}</p>
                </header>
                <section class="modal-card-body">
                    <div class="card">
			            <div class="card-content">                            
				            <template v-if="loading"><loading></loading></template>
				            <template v-else>
                                <toggle-switch :values="languages" :selected.sync="language" default="en"></toggle-switch>
                                <table v-if="histories != null && histories.length > 0">
                                    <thead>
                                        <tr>
                                            <th>{{modificationViewerChangeTypeLabel}}</th>
                                            <th>{{modificationViewerChangeDateLabel}}</th>
                                            <th>{{modificationViewerReferenceNumberLabel}}</th>
                                            <th v-if="hasNameColumn">{{modificationViewerNameLabel}}</th>
                                            <th v-if="hasOriginalNameColumn">{{modificationViewerOriginalNameLabel}}</th>
                                            <th v-if="hasTextColumn">{{modificationViewerTextLabel}}</th>
                                            <th v-if="hasFooterColumn">{{modificationViewerFooterLabel}}</th>
                                            <th v-if="hasDescriptionColumn">{{modificationViewerDescriptionLabel}}</th>
                                            <th v-if="hasDetailsTextColumn">{{modificationViewerDetailsLabel}}</th>
                                            <th>{{modificationViewerDocumentSymbolLabel}}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="history in histories" :key="history.id">
                                            <td>
                                                <i v-if="history.changeType == 'Added'" class="fas fa-plus"></i>
                                                <i v-if="history.changeType == 'Updated'" class="fas fa-pen"></i>
                                                <i v-if="history.changeType == 'Deleted'" class="fas fa-trash"></i>
                                            </td>
                                            <td>{{history.formattedChangeDate}}</td>
                                            <td>{{history.referenceNumber}}</td>
                                            <td v-if="hasNameColumn">
                                                <span v-if="language =='en'" v-html="history.nameEn"></span>
                                                <span v-if="language =='fr'" v-html="history.nameFr"></span>
                                                <span v-if="language =='es'" v-html="history.nameEs"></span>
                                            </td>
                                            <td v-if="hasOriginalNameColumn" v-html="history.originalName"></td>
                                            <td v-if="hasTextColumn">
                                                <span v-if="language =='en'" v-html="history.textEn"></span>
                                                <span v-if="language =='fr'" v-html="history.textFr"></span>
                                                <span v-if="language =='es'" v-html="history.textEs"></span>
                                            </td>
                                            <td v-if="hasFooterColumn">
                                                <span v-if="language =='en'" v-html="history.footerEn"></span>
                                                <span v-if="language =='fr'" v-html="history.footerFr"></span>
                                                <span v-if="language =='es'" v-html="history.footerEs"></span>
                                            </td>
                                            <td v-if="hasDescriptionColumn">
                                                <span v-if="language =='en'" v-html="history.descriptionEn"></span>
                                                <span v-if="language =='fr'" v-html="history.descriptionFr"></span>
                                                <span v-if="language =='es'" v-html="history.descriptionEs"></span>
                                            </td>
                                            <td v-if="hasDetailsTextColumn">
                                                <span v-if="language =='en'" v-html="history.detailsTextEn"></span>
                                                <span v-if="language =='fr'" v-html="history.detailsTextFr"></span>
                                                <span v-if="language =='es'" v-html="history.detailsTextEs"></span>
                                            </td>
                                            <td>{{history.documentSymbol}}</td>
                                        </tr>
                                    </tbody>
                                </table>
				            </template>
			            </div>
		            </div>
                </section>
                <footer class="modal-card-foot buttons">
					<button type="button" class="button is-primary" @click="close">{{modificationViewerCloseLabel}}</button>
                </footer>
            </div>
        </b-modal>
	`
});